<template>
  <div>
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-card
          @click.stop="didTapFileInput"
          :class="{ 'breakpoint': $vuetify.breakpoint.mdAndUp }"
          :style="'border-radius: 10px; overflow: hidden;'"
          elevation="6"
          hover
        >
          <input
            id="coverFileInput"
            type="file"
            accept="image/png, image/jpeg"
            @change="didChangeFile"
          />
          <v-img id="previewImage" :aspect-ratio="cover.width/cover.height" style="max-width: 500px" :src="cover.url" />
          <v-fade-transition>
            <v-overlay absolute color="accent" opacity="0.75" v-if="hover">
              <v-btn text>
                <v-icon>file_upload</v-icon>Enviar capa
              </v-btn>
            </v-overlay>
          </v-fade-transition>
        </v-card>
      </template>
    </v-hover>
    <UploadDialogs
      :is-uploading="uploading"
      :upload-progress="progress"
      :show-snackbar="snackbar"
      :upload-name="uploadName"
      :upload-size="uploadSize"
      @hideSnackbar="snackbar = false"
      @didTapCancel="didTapCancel"
    />
  </div>
</template>

<script>
import { rdb } from "@/firebase/config";
import UploadDialogs from "@/components/dialogs/PhotoUpload";
import FileUploadMixin from "@/mixins/fileupload";

export default {
  mixins: [FileUploadMixin],
  components: { UploadDialogs },
  data: () => ({
    cover: { width: 1, height: 1, url: "" },
    snackbar: false
  }),
  firebase: {
    cover: rdb.ref("bookCover")
  },
  computed: {
    uploadOnChange() {
      return true;
    },
    filepath() {
      return "bookCover";
    },
    fileinputID() {
      return 'coverFileInput'
    },
  },
  methods: {
    uploadFinished(photoURL) {
      this.uploading = false;
      this.file = null;
      this.previewFile = null;
      this.snackbar = true;
      this.progress = 0;
      this.$firebaseRefs.cover.update({
        url: photoURL,
        width: this.previewWidth,
        height: this.previewHeight
      });
    }
  }
};
</script>

<style>
input[type="file"] {
  display: none;
}

.breakpoint {
  z-index: 2;
  margin-right: -60px;
}
</style>